import { functionBaseUrl } from "../../../../../common/firebase";
import { apiClient } from "../../../../../services/api";
import { LLM_URL } from "../constants/LLM_URL";

const PIPELINE_HEADERS = {
  customerId: "sportsbox-internal-server",
  sportsboxApiKey: "sbx_7c46444a532c462fa3ca29a2ea4fbafd",
};

export const llmService = {
  async analyzeVideoQuery({
    env,
    metadataMap,
    query,
    sessionId,
    userId,
    videoId,
    videoIsAnalyzed,
    videoUrl,
  }) {
    const url = `${LLM_URL}/analyze-video-query${env ? `?env=${env}` : ""}`;

    const body = {
      metadataMap,
      query,
      sessionId,
      userId,
      videoUrl,
    };

    if (videoId) {
      body.videoId = videoId;
    }
    if (typeof videoIsAnalyzed === "boolean") {
      body.videoIsAnalyzed = videoIsAnalyzed;
    }

    return fetch(url, {
      body: JSON.stringify(body),
      headers: {
        ...PIPELINE_HEADERS,
        "Content-Type": "application/json",
      },
      method: "POST",
    });
  },

  async createSessionFnBackend({ env, userId }) {
    return apiClient.request("/api/v1/llm/create-session-web", {
      method: "POST",
      body: {
        userId,
        overwriteEnv: env,
      },
      requireAuth: true,
    });
  },

  async createSession({ env, userId }) {
    const url = `${LLM_URL}/create-session${env ? `?env=${env}` : ""}`;

    return fetch(url, {
      body: JSON.stringify({ user_id: userId }),
      headers: {
        ...PIPELINE_HEADERS,
        "Content-Type": "application/json",
      },
      method: "POST",
    });
  },

  async getSessions({ env, userId }) {
    const url = `${LLM_URL}/user-sessions?userId=${encodeURIComponent(userId)}${
      env ? `&env=${env}` : ""
    }`;

    return fetch(url, {
      headers: {
        ...PIPELINE_HEADERS,
        "Content-Type": "application/json",
      },
      method: "GET",
    });
  },

  async updateSessionDisplayName({ displayName, env, sessionId }) {
    const url = `${LLM_URL}/update-session-display-name/${sessionId}${
      env ? `?env=${env}` : ""
    }`;

    return fetch(url, {
      body: JSON.stringify({ displayName }),
      headers: {
        ...PIPELINE_HEADERS,
        "Content-Type": "application/json",
      },
      method: "PATCH",
    });
  },

  async deleteSession({ env, sessionId }) {
    const url = `${LLM_URL}/delete-session/${sessionId}${
      env ? `?env=${env}` : ""
    }`;

    return fetch(url, {
      headers: {
        ...PIPELINE_HEADERS,
        "Content-Type": "application/json",
      },
      method: "DELETE",
    });
  },

  async getSessionById({ env, sessionId }) {
    const url = `${LLM_URL}/chat-session/${sessionId}${
      env ? `?env=${env}` : ""
    }`;

    return fetch(url, {
      headers: {
        ...PIPELINE_HEADERS,
        "Content-Type": "application/json",
      },
      method: "GET",
    });
  },

  async readQueryStream({ fileParts, env, sessionId, userId, userMsg }) {
    const parts = [{ text: userMsg }, ...(fileParts || [])];

    const body = {
      input: {
        message: fileParts?.length ? { parts, role: "user" } : userMsg,
        session_id: sessionId,
        user_id: userId,
      },
    };

    const url = env ? `${LLM_URL}/query?env=${env}` : `${LLM_URL}/query`;

    return fetch(url, {
      body: JSON.stringify(body),
      headers: {
        ...PIPELINE_HEADERS,
        "Content-Type": "application/json",
      },
      method: "POST",
    });
  },
};
